// Package Imports
import { toJS } from "mobx";

// Package Imports
import NeedTypeEnum from "../../../../constants/NeedTypeEnum";
import OptimizationStore from "../../store/OptimizationStore";
import AuthStore from "../../../login/store/AuthStore";

const generateChangesSecondaryLAStructure = (data, needType) => {
  
  let productListData = toJS(OptimizationStore.product_list_data);
  const journeyData = toJS(AuthStore.journeyData);
  let { family_details_list, journey_details } = journeyData;

  let secondaryLADetails = family_details_list.find(
    (familyData) => familyData.id === data.secondary_la_id
  );
  let riskList = [];
  let productWiseRiskList = [];

  if (journey_details.high_risk_selected) riskList.push("high");
  riskList = [...riskList, ...["medium", "low"]];
  riskList.forEach((item) => {
    productWiseRiskList.push({
      risk: item,
      BI: {},
      bi_request: {},
      update_BI: false,
    });
  });

  productListData.map((item) => {
    item.data.forEach((value) => {
      if (!Array.isArray(value.BI)) {
        // For single products
        if (
          item.need_unique_name === needType &&
          value.family_product_id === data.family_product_id
        ) {
          value.life_assured_details = secondaryLADetails;
          value.proposer_details = {};
          value.BI = { risk: "high", BI: {}, bi_request: {}, update_BI: false };
          // value.selectedRisk = "";
          // value.selected_risk_type = "";
          value.changeProductList = value.changeProductList || [];
          value.fieldChanged = false;
          value.update_BI = false;
        }
      } else {
        // For multiple products to show in a tab
        value.BI.forEach((productDetails) => {
          // value.selectedRisk = "";
          // value.selected_risk_type = "";

          if (
            item.need_unique_name === needType &&
            value.family_product_id === data.family_product_id
          ) {
            value.secondary_la_Details = secondaryLADetails;
            value.proposer_details = {};
            value.BI = productWiseRiskList;
            productDetails.changeProductList =
              productDetails.changeProductList || [];
            productDetails.fieldChanged = false;
            productDetails.update_BI = false;
          }
        });
      }
    });
    return item;
  });
  OptimizationStore.product_list_data = [...productListData];
};

export default generateChangesSecondaryLAStructure;
